
  /**
   * @license
   * author: epignosis front-end team
   * @epignosis_llc/gnosis.js v6.0.0
   * Released under the MIT license.
   */

import getBuiltIn$1 from './get-built-in.js';
import defineBuiltInAccessor$1 from './define-built-in-accessor.js';
import wellKnownSymbol$1 from './well-known-symbol.js';
import descriptors from './descriptors.js';

var getBuiltIn = getBuiltIn$1;
var defineBuiltInAccessor = defineBuiltInAccessor$1;
var wellKnownSymbol = wellKnownSymbol$1;
var DESCRIPTORS = descriptors;

var SPECIES = wellKnownSymbol('species');

var setSpecies = function (CONSTRUCTOR_NAME) {
  var Constructor = getBuiltIn(CONSTRUCTOR_NAME);

  if (DESCRIPTORS && Constructor && !Constructor[SPECIES]) {
    defineBuiltInAccessor(Constructor, SPECIES, {
      configurable: true,
      get: function () { return this; }
    });
  }
};

export { setSpecies as default };
//# sourceMappingURL=set-species.js.map
